module.exports = __webpack_public_path__ + "static/img/新闻5@2xs.b1f9a28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/新闻5@2xs.png
// module id = bZ36
// module chunks = 0